import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Container, Box } from '@mui/material';
import Layout from '../../components/Layout';
import { useTheme } from '../../hooks';

import Heading from '../../components/Heading';
import Card from '../../components/Dashboard/Card';
import Nodes from '../../components/Dashboard/Node';
import { MainCardDesktop, MainCardMobile } from '../../components/Dashboard/Cards/MainCard';
import { updateThorPrice, updateAvaxPrice } from '../../redux/actions/web3Actions';
import Slider from 'react-slick';
import styles from '../../components/Dashboard/style.module.css';
import './slick.css';
import { fetchHistoricalData } from '../../api/coinmarketcap_api';
import { useQuery } from 'react-query';
import { getNumber } from '../../utils/utils';
import { useCashOutReward, useGetTotalRewards, useGetNodeNumber } from '../../hooks/token';
import { updateActiveLinkState } from '../../redux/actions/uiActions';
import { darkTheme, lightTheme } from '../../theme/materialUiTheme';

// assets
import imgGraph from '../../assets/images/updown-graph.png';
import imgCup from '../../assets/images/cup.png';
import imgDollar from '../../assets/images/dollar.png';
import imgEarth from '../../assets/images/earth.png';

function Dashboard() {
  const dispatch = useDispatch();
  const [mainCard, setMainCard] = useState(false);
  const { thorPrice } = useSelector((state) => state.web3);
  const { avaxPrice } = useSelector((state) => state.web3);
  const { data: avaxPrices } = useQuery('avaxPrices', () => fetchHistoricalData(5805, 'hourly', 24));
  const { data: thorPrices } = useQuery('thorPrices', () => fetchHistoricalData(15789, 'hourly', 24));
  const { cashOutReward, isLoading } = useCashOutReward();
  const [myNodesState, setMyNodesState] = useState(0);
  const { nodesData } = useSelector((state) => state.ui);
  const navigate = useNavigate();
  const navClickHandler = (idx) => {
    navigate('nodes');
    setTimeout(() => {
      dispatch(updateActiveLinkState(1, true));
    }, 1000);
    dispatch(updateActiveLinkState(idx, false));
  };
  // const rewardData = useGetTotalRewards();
  const numberOfNodes = useGetNodeNumber();

  // const totalRewards = rewardData?.data && !rewardData.isLoading ? Number(getNumber(rewardData.data, 6)).toFixed(4) : '0';
  const [totalRewards, setTotalRewards] = useState(0);

  useEffect(() => {
    if (nodesData.length !== 0) {
      const nodes = nodesData.reduce((total, el) => {
        return (total += el.noded);
      }, 0);
      setMyNodesState(nodes);
    }
  }, [nodesData]);

  useEffect(() => {
    const price = thorPrices?.data?.quotes[23]?.quote.USD.price.toFixed(2);
    // setThorPrice(price);
    dispatch(updateThorPrice(price));
    // eslint-disable-next-line
  }, [thorPrices]);

  useEffect(() => {
    const price = avaxPrices?.data?.quotes[23]?.quote.USD.price.toFixed(2);
    // setAvaxPrice(price);
    dispatch(updateAvaxPrice(price));
    // eslint-disable-next-line
  }, [avaxPrices]);

  const handleChangeTotalRewards = (totalRewards) => {
    setTotalRewards(Number(totalRewards).toFixed(3));
  };

  const { theme } = useTheme();

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    arrows: false,
    dotsClass: theme === 'light' ? lightTheme.palette.className.className2 : darkTheme.palette.className.className2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Layout>
      <Box marginY={'20px'}>
        <Heading title={'dashboard'} />
      </Box>
      <Container maxWidth="xl">
        <Slider {...settings}>
          <Box paddingX={'10px'}>
            <Card
              title="Rewards"
              number={totalRewards === undefined ? '...' : totalRewards}
              btnLabel="collect all"
              icon={imgCup}
              onClick={() => {
                cashOutReward([undefined]);
              }}
              onChangeTotalRewards={handleChangeTotalRewards}
            />
          </Box>
          <Box paddingX={'10px'}>
            <Card
              title="Thor Price"
              noBoxes={true}
              number={`$${thorPrice === undefined ? '...' : thorPrice}`}
              avaxPrice={`$${avaxPrice === undefined ? '...' : avaxPrice}`}
              image={imgGraph}
              icon={imgDollar}
              path="https://dexscreener.com/avalanche/0x95189f25b4609120f72783e883640216e92732da"
              btnLabel="view chart"
            />
          </Box>
          <Box paddingX={'10px'}>
            <Card
              title="My Nodes"
              // number={myNodesState === undefined ? '...' : myNodesState.toString()}
              number={numberOfNodes?.data === undefined ? '...' : numberOfNodes?.data}
              btnLabel="view nodes"
              onClick={() => {
                navClickHandler(1);
              }}
              icon={imgEarth}
              hideHover={true}
            />
          </Box>
        </Slider>
      </Container>
      <Box marginY={'20px'}>
        <Heading title={'create node'} />
      </Box>

      <Container maxWidth="xl">
        <MainCardMobile onClick={setMainCard} currentCard={mainCard} />
        <Box
          display={{
            xs: 'none',
            sm: 'none',
            md: 'none',
            lg: 'block',
          }}
          className={styles.mainContainer}
        >
          {Boolean(mainCard) ? (
            <Nodes onClick={setMainCard} currentCard={mainCard} />
          ) : (
            <MainCardDesktop onClick={setMainCard} />
          )}
        </Box>
      </Container>
    </Layout>
  );
}

export default Dashboard;
